// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23E6512D%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%0A%3E%3Cpolyline points=%276 9 12 15 18 9%27 /%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown--du3m7 {
  position: relative;
  width: auto;
  color: black;
  text-transform: uppercase;
}[dir] .dropdown--du3m7 {
  background-color: white;
  margin: 0 auto;
  box-shadow: none;
  border-bottom: 1px solid black;
  border-radius: 0;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}[dir=ltr] .dropdown--du3m7 {
  padding: 0 30px 0 5px;
  background-position: right;
}[dir=rtl] .dropdown--du3m7 {
  padding: 0 5px 0 30px;
  background-position: left;
}

.dropdown--du3m7:focus-visible {
  outline: none;
}

.subjectPickerWrapper--lD9tr {
  width: 305%;
  position: absolute;
  z-index: 30;
}

[dir] .subjectPickerWrapper--lD9tr {
  transform: translateY(10px);
}

[dir=ltr] .subjectPickerWrapper--lD9tr {
  left: -62px;
  text-align: left;
}

[dir=rtl] .subjectPickerWrapper--lD9tr {
  right: -62px;
  text-align: right;
}

.subjectPickerWrapper--lD9tr .icon-container:before {
  top: -6px;
}

[dir=ltr] .subjectPickerWrapper--lD9tr .icon-container:before {
  left: 50vw;
}

[dir=rtl] .subjectPickerWrapper--lD9tr .icon-container:before {
  right: 50vw;
}

@media (min-width: 768px) {
  [dir=ltr] .subjectPickerWrapper--lD9tr .icon-container:before {
    left: calc(40px + 15vw);
  }
  [dir=rtl] .subjectPickerWrapper--lD9tr .icon-container:before {
    right: calc(40px + 15vw);
  }
}
@media (min-width: 1400px) {
  [dir=ltr] .subjectPickerWrapper--lD9tr {
    left: -10px;
  }
  [dir=rtl] .subjectPickerWrapper--lD9tr {
    right: -10px;
  }
  [dir=ltr] .subjectPickerWrapper--lD9tr .icon-container:before {
    left: calc(50vw - 440px);
  }
  [dir=rtl] .subjectPickerWrapper--lD9tr .icon-container:before {
    right: calc(50vw - 440px);
  }
}

@media screen and (max-width: 767px) {
  .subjectPickerWrapper--lD9tr {
    width: 100vw;
  }
  [dir] .subjectPickerWrapper--lD9tr {
    transform: translateY(10px);
  }
  [dir=ltr] .subjectPickerWrapper--lD9tr {
    left: calc(-50vw + 50%);
  }
  [dir=rtl] .subjectPickerWrapper--lD9tr {
    right: calc(-50vw + 50%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/js/components/OverviewSingleScore/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EAEX,YAAY;EAMZ,yBAAyB;AAI3B,CAdA;EAGE,uBAAuB;EAEvB,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAGhB,4BAA4B;EAE5B,yDAAuR;AACzR,CAdA;EASE,qBAAqB;EAGrB,0BAA0B;AAE5B,CAdA;EASE,qBAAqB;EAGrB,yBAA0B;AAE5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAIlB,WAAW;AACb;;AAPA;EAKE,2BAA2B;AAE7B;;AAPA;EAGE,WAAW;EACX,gBAAgB;AAGlB;;AAPA;EAGE,YAAW;EACX,iBAAgB;AAGlB;;AAEA;EACE,SAAS;AAEX;;AAHA;EAEE,UAAU;AACZ;;AAHA;EAEE,WAAU;AACZ;;AAEA;EACE;IACE,uBAAuB;EACzB;EAFA;IACE,wBAAuB;EACzB;AACF;AACA;EACE;IACE,WAAW;EACb;EAFA;IACE,YAAW;EACb;EACA;IACE,wBAAwB;EAC1B;EAFA;IACE,yBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,YAAY;EAGd;EAJA;IAGE,2BAA2B;EAC7B;EAJA;IAEE,uBAAuB;EAEzB;EAJA;IAEE,wBAAuB;EAEzB;AACF","sourcesContent":[".dropdown {\n  position: relative;\n  width: auto;\n  background-color: white;\n  color: black;\n  margin: 0 auto;\n  box-shadow: none;\n  border-bottom: 1px solid black;\n  border-radius: 0;\n  padding: 0 30px 0 5px;\n  text-transform: uppercase;\n  background-repeat: no-repeat;\n  background-position: right;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23E6512D' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%0A%3E%3Cpolyline points='6 9 12 15 18 9' /%3E%3C/svg%3E\");\n}\n\n.dropdown:focus-visible {\n  outline: none;\n}\n\n.subjectPickerWrapper {\n  width: 305%;\n  position: absolute;\n  left: -62px;\n  text-align: left;\n  transform: translateY(10px);\n  z-index: 30;\n}\n\n.subjectPickerWrapper :global(.icon-container:before) {\n  top: -6px;\n  left: 50vw;\n}\n\n@media (min-width: 768px) {\n  .subjectPickerWrapper :global(.icon-container:before) {\n    left: calc(40px + 15vw);\n  }\n}\n@media (min-width: 1400px) {\n  .subjectPickerWrapper {\n    left: -10px;\n  }\n  .subjectPickerWrapper :global(.icon-container:before) {\n    left: calc(50vw - 440px);\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .subjectPickerWrapper {\n    width: 100vw;\n    left: calc(-50vw + 50%);\n    transform: translateY(10px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown": `dropdown--du3m7`,
	"subjectPickerWrapper": `subjectPickerWrapper--lD9tr`
};
export default ___CSS_LOADER_EXPORT___;
